import { createFileRoute, redirect } from "@tanstack/react-router";
import { MerchStaffView } from "../../components/merch/staff-view";
import { listSearch } from "../../lib/list-page/list-search";
import { canEditMerchStaff } from "../../lib/merch/access";

/** Merchandising › Staff: the ADMIN logins that may use the desk. SUPER_ADMIN only (the API answers 403 to anyone else). */
export const Route = createFileRoute("/_app/merchandising/staff")({
	validateSearch: listSearch(["name"] as const),
	beforeLoad: ({ context }) => {
		if (!canEditMerchStaff(context.session)) throw redirect({ to: "/merchandising/orders" });
	},
	component: StaffPage,
});

function StaffPage() {
	return <MerchStaffView search={Route.useSearch()} navigate={Route.useNavigate()} />;
}
